'use client'

import { useRef, useState } from 'react'

import Icon from '@/components/Icon/Icon'
import Button from '@/components/Button/Button'
import Input from '@/components/Input/Input'

import { useAuth, AUTH_TYPES } from './AuthContext'

import styles from './Auth.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default function ForgottenPasswordForm() {
    const { sendPasswordResetEmail, setSelectedType } = useAuth()
    const emailInput = useRef(null)
    const [loading, setLoading] = useState(false)

    const sendResetEmail = async () => {
        if (loading) return
        setLoading(true)
        try {
            await sendPasswordResetEmail(emailInput.current.value)
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            <form
                className={classes('form')}
                onSubmit={(e) => e.preventDefault()}
                onKeyUp={({ key }) => key == 'Enter' && sendResetEmail()}
            >
                <h1 className={classes('title')}>Reset your password</h1>
                <p className={classes('subtext')}>No worries, we'll send you reset instructions.</p>
                <div className={classes('input-container')}>
                    <Input
                        type="email"
                        placeholder="Your email"
                        required={true}
                        ref={emailInput}
                        autoComplete="username"
                    />
                    <div className={classes('error-icon')}>
                        <Icon name="alert-circle" width={20} height={20} />
                    </div>
                </div>
            </form>
            <Button
                className={classes('login-button')}
                onClick={(e) => {
                    e.preventDefault()
                    sendResetEmail()
                }}
                text={loading ? "Sending reset email..." : "Reset password"}
                disabled={loading}
            />
            <span className={classes('login-link')}>
                <a href="#" onClick={() => setSelectedType(AUTH_TYPES.LOGIN)}>
                    Back to login
                </a>
            </span>
        </>
    )
}
